import { render, staticRenderFns } from "./NewW2Channel.vue?vue&type=template&id=1ae3c9fe&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./NewW2Channel.vue?vue&type=script&lang=js"
export * from "./NewW2Channel.vue?vue&type=script&lang=js"
import style0 from "./NewW2Channel.vue?vue&type=style&index=0&id=1ae3c9fe&prod&lang=scss&scoped=true"
import style1 from "./NewW2Channel.vue?vue&type=style&index=1&id=1ae3c9fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3c9fe",
  null
  
)

export default component.exports